// Shared Mock API client to avoid duplication and help Rollup/Vite static analysis
const mockResponse = { data: [], error: null, count: 0 };

const apiClient = {
    from: () => apiClient,
    select: () => apiClient,
    insert: () => apiClient,
    update: () => apiClient,
    delete: () => apiClient,
    eq: () => apiClient,
    gte: () => apiClient,
    lte: () => apiClient,
    ilike: () => apiClient,
    single: () => apiClient,
    order: () => apiClient,
    range: () => apiClient,
    limit: () => apiClient,
    rpc: () => apiClient,
    auth: {
        getUser: async () => ({ data: { user: { id: 1 } }, error: null }),
        getSession: async () => ({ data: { session: null }, error: null }),
        signInWithPassword: async () => ({ data: { user: { id: 1 }, session: {} }, error: null }),
        signOut: async () => ({ error: null })
    },
    then: (res) => {
        if (typeof res === 'function') {
            return Promise.resolve(res(mockResponse));
        }
        return Promise.resolve(mockResponse);
    }
};

export default apiClient;
export { apiClient };
